
import { Link } from "react-router-dom";

export default function Footer({ settings }) {
  const tel = `tel:+1${(settings.phone || "").replace(/\D/g, "")}`;
  return (
    <footer data-testid="site-footer" className="bg-stone-950 pb-8 pt-12 text-stone-400">
      <div className="mx-auto grid max-w-7xl gap-8 px-5 sm:px-8 md:grid-cols-3">
        <div>
          <Link to="/"><img src="/assets/logo-lavender.png" alt="Pawtastic Cuts" className="h-12 w-auto" /></Link>
          <p className="mt-5 max-w-xs text-sm leading-relaxed">
            Dog grooming, baths and nail care in Wethersfield, CT.
          </p>
        </div>
        <div>
          <p className="text-sm font-bold text-lavender-400">Explore</p>
          <nav className="mt-5 flex flex-col gap-3 text-sm" data-testid="footer-nav">
            <Link to="/services" data-testid="footer-services-link" className="w-fit transition-colors hover:text-lavender-300">Services &amp; Pricing</Link>
            {settings.showGroomers !== false && (
              <Link to="/groomers" data-testid="footer-groomers-link" className="w-fit transition-colors hover:text-lavender-300">Meet Our Groomers</Link>
            )}
            {settings.showReviews !== false && (
              <Link to="/reviews" data-testid="footer-reviews-link" className="w-fit transition-colors hover:text-lavender-300">Reviews</Link>
            )}
            <Link to="/visit" data-testid="footer-contact-link" className="w-fit transition-colors hover:text-lavender-300">Book an Appointment</Link>
            <Link to="/waiver" data-testid="footer-waiver-link" className="w-fit transition-colors hover:text-lavender-300">Grooming Waiver</Link>
            <Link to="/groomiq" data-testid="footer-groomiq-link" className="w-fit transition-colors hover:text-indigo-300">GroomIQ App</Link>
          </nav>
        </div>
        <div>
          <p className="text-sm font-bold text-lavender-400">Visit Us</p>
          <div className="mt-5 space-y-3 text-sm">
            <p data-testid="footer-address">{settings.address}</p>
            <p data-testid="footer-hours">{settings.hours}</p>
            <a data-testid="footer-phone-link" href={tel} className="block w-fit transition-colors hover:text-lavender-300">{settings.phone}</a>
            <a data-testid="footer-email-link" href={`mailto:${settings.email}`} className="block w-fit break-all transition-colors hover:text-lavender-300">{settings.email}</a>
            <a href={settings.facebookUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook-link" className="block w-fit transition-colors hover:text-lavender-300">Follow us on Facebook</a>
          </div>
        </div>
      </div>
      <div className="mx-auto mt-10 flex max-w-7xl flex-wrap items-center justify-between gap-3 border-t border-white/10 px-5 pt-6 text-xs text-stone-500 sm:px-8">
        <p>© {new Date().getFullYear()} Pawtastic Cuts · Wethersfield, CT</p>
        <div className="flex items-center gap-4">
          <p className="text-lavender-300">Dog grooming in Wethersfield, CT.</p>
          <Link to="/admin" data-testid="footer-admin-link" className="text-stone-500 transition-colors hover:text-lavender-300">Admin</Link>
        </div>
      </div>
    </footer>
  );
}
